import { F32 } from '../engine/typed-arrays.js';

function _defaultAllocate() {
  return new F32(16);
}
let _allocate;
function allocateMat4() {
  return (_allocate ?? _defaultAllocate)();
}
function allocateMat4Storage() {
  return allocateMat4();
}
function _setHpmAllocator(allocate) {
  _allocate = allocate;
}
function _resetMatrixAllocatorForTests() {
  _allocate = void 0;
}

export { _resetMatrixAllocatorForTests, _setHpmAllocator, allocateMat4, allocateMat4Storage };
//# sourceMappingURL=_matrix-allocator.js.map
